import "./cwPrint.scss";
import { convertToJalaliWithTime, convertToJalaliWithoutTime, formatDate } from "../../../tools/tools";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useRef, useState } from "react";
import html2canvas from "html2canvas";
const CWPrint = ({ print, lang = "fa", canvas = false, value }) => {
	const formData = useSelector((state) => state?.another?._currentUser);
	const dispatch = useDispatch();
	const [language, setLanguage] = useState("");
	useEffect(() => {
		setLanguage(lang);
		if (canvas) {
			setIsCanvas(true);
		}
	}, [lang, canvas]);
	const [isCanvas, setIsCanvas] = useState(false);
	const myref = useRef("");

	useEffect(() => {
		if (isCanvas) {
			html2canvas(myref?.current, {
				allowTaint: true,
				useCORS: true,
			}).then((canvas) => {
				const imgData = canvas.toDataURL("image/png");
				if (typeof value === "function") value(imgData); // Save the canvas image in the component's state
			});
		}
	}, [isCanvas]);
	return (
		<>
			<div ref={myref} className={`${isCanvas ? "canvas-document" : ""}`}>
				{lang === "fa" ? (
					<div className="print-document-cw">
						<div className="header-doc border-row">
							<div className="row-doc">
								<div className="item-logo">
									<img src={process.env.PUBLIC_URL + "/assets/images/logo-small.png"} alt="" />
								</div>
								<div className="item-title">
									<div className="hold-title">
										<h2>فرم تغییرمالکیت سیم‌کارت</h2>
									</div>
								</div>
								<div className="item-date">
									تاریخ: <span dir="ltr">{convertToJalaliWithTime(new Date().toISOString())}</span>
								</div>
							</div>
						</div>
						<div className="holder-with-label border-row">
							<div className="item-block item-none">
								<div className="holder-list">
									<div className="holder-item-row">
										<ul>
											<li>
												<div className="label">شماره آپتل :</div>
												<div className="value">
													<span dir="ltr">{print?.seller?.msisdn}</span>
												</div>
											</li>
											<li>
												<div className="label"> شماره کیت سیم کارت :</div>
												<div className="value">{print?.prefactor?.iccid?.slice(10, 20)}</div>
											</li>
										</ul>
									</div>
								</div>
							</div>
							<div className="item-block" data-content="اطلاعات انتقال گیرنده (خریدار)">
								<div className="item-block-prefix">
									<span>اطلاعات انتقال گیرنده (خریدار)</span>
								</div>
								<div className="holder-list">
									<div className="holder-item-row">
										<ul>
											<li>
												<div className="label">نام : </div>
												<div className="value">{print?.buyer?.profile?.fname}</div>
											</li>
											<li>
												<div className="label"> نام خانوادگی :</div>
												<div className="value">{print?.buyer?.profile?.lname}</div>
											</li>
											<li>
												<div className="label"> شماره مدرک شناسایی:</div>
												<div className="value">{print?.buyer?.profile?.certno}</div>
											</li>
											<li>
												<div className="label"> نام پدر:</div>
												<div className="value">{print?.buyer?.profile?.fathername}</div>
											</li>
										</ul>
									</div>
									<div className="holder-item-row">
										<ul>
											<li>
												<div className="label"> تاریخ تولد :</div>
												<div className="value">{convertToJalaliWithoutTime(print?.buyer?.profile?.birthdate)}</div>
											</li>
											<li>
												<div className="label">کدپستی : </div>
												<div className="value">{print?.buyer?.profile?.postalcode}</div>
											</li>
											<li>
												<div className="label"> استان :</div>
												<div className="value">{print?.buyer?.profile?.txtProvince}</div>
											</li>
											<li>
												<div className="label"> شهر/روستا :</div>
												<div className="value">{print?.buyer?.profile?.txtCity}</div>
											</li>
										</ul>
									</div>
									<div className="holder-item-row">
										<ul>
											<li>
												<div className="label">آدرس دقیق (محل سکونت / تحویل سیم کارت) :</div>
												<div className="value">
													{print?.buyer?.profile?.mainstreet}, {print?.buyer?.profile?.auxiliaryroad}, {print?.buyer?.profile?.alley}, پلاک
													{print?.buyer?.profile?.buildingno}, طبقه {print?.buyer?.profile?.floor}, واحد {print?.buyer?.profile?.unit}
												</div>
											</li>
											<li>
												<div className="label">شماره تلفن همراه :</div>
												<div className="value">
													<span dir="ltr">{print?.buyer?.profile?.smsmobileno}</span>
												</div>
											</li>
										</ul>
									</div>
								</div>
							</div>
							<div className="item-block" data-content="اطلاعات انتقال دهنده (فروشنده)">
								<div className="item-block-prefix">
									<span>اطلاعات انتقال دهنده (فروشنده)</span>
								</div>
								<div className="holder-list">
									<div className="holder-item-row">
										<ul>
											<li>
												<div className="label">نام : </div>
												<div className="value">{print?.seller?.profile?.stR_FName}</div>
											</li>
											<li>
												<div className="label"> نام خانوادگی :</div>
												<div className="value">{print?.seller?.profile?.stR_LName}</div>
											</li>
											<li>
												<div className="label"> شماره مدرک شناسایی:</div>
												<div className="value">{print?.seller?.profile?.stR_CertNo}</div>
											</li>
											<li>
												<div className="label"> نام پدر:</div>
												<div className="value">{print?.seller?.profile?.stR_FatherName}</div>
											</li>
										</ul>
									</div>
									<div className="holder-item-row">
										<ul>
											<li>
												<div className="label"> تاریخ تولد :</div>
												<div className="value">{convertToJalaliWithTime(print?.seller?.profile?.dtE_BirthDate)}</div>
											</li>
											<li>
												<div className="label">کدپستی : </div>
												<div className="value">{print?.seller?.profile?.address?.stR_PostalCode}</div>
											</li>
											<li>
												<div className="label"> استان :</div>
												<div className="value">{print?.seller?.profile?.province?.stR_ProvinceName}</div>
											</li>
											<li>
												<div className="label"> شهر/روستا :</div>
												<div className="value">{print?.seller?.profile?.city?.stR_CityName}</div>
											</li>
										</ul>
									</div>
									<div className="holder-item-row">
										<ul>
											<li>
												<div className="label">آدرس دقیق (محل سکونت / تحویل سیم کارت) :</div>
												<div className="value">
													{print?.seller?.profile?.address?.stR_MainStreet}, {print?.seller?.profile?.address?.stR_AuxiliaryRoad},{" "}
													{print?.seller?.profile?.address?.stR_Alley},پلاک {print?.seller?.profile?.address?.stR_BuildingNo}, طبقه{" "}
													{print?.seller?.profile?.address?.stR_Floor}, واحد {print?.seller?.profile?.address?.stR_Unit}
												</div>
											</li>
											<li>
												<div className="label">شماره تلفن همراه :</div>
												<div className="value">{print?.seller?.smsmobile}</div>
											</li>
										</ul>
									</div>
								</div>
							</div>
							<div className="item-block" data-content="تعهدات انتقال گیرنده">
								<div className="item-block-prefix">
									<span>تعهدات انتقال گیرنده</span>
								</div>
								<div className="holder-list">
									<div className="holder-item-row">
										<div className="item-sign">
											<p>
												-اینجانب ....{print?.buyer?.profile?.fname + " " + print?.buyer?.profile?.lname}.... متعهد می شوم در صورت بر هم خوردن این
												معامله تحت هر عنوان و به هر علت هیچ گونه ادعائی نسبت به شرکت نگین ارتباطات آوا نداشته باشم و با امضاء این سند جایگزین انتقال
												دهنده شده و کلیه مسئولیت های مالی و غیرمالی ناشی از اشتراک این شماره همراه در برابر شرکت نگین ارتباطات آوا و سایر مراجع ذیصلاح
												بر عهده ی اینجانب خواهد بود . همچنین تایید می نمایم یک نسخه از فرم تغییر مالکیت را از فروشنده دریافت نموده ام .
												<br />
												-انتقال گیرنده متعهد می شود جهت نقل و انتقال بعدی ضمن مراجعه به عامل فروش این شرکت فرم نقل و انتقالات را تکمیل نماید و در غیر
												این صورت نقل و انتقال انجام شده در برابر شرکت نگین ارتباطات آوا قابل استفاده نخواهد بود .
											</p>
										</div>
									</div>
								</div>
							</div>
							<div className="item-block" data-content="تعهدات انتقال دهنده">
								<div className="item-block-prefix">
									<span>تعهدات انتقال دهنده</span>
								</div>
								<div className="holder-list">
									<div className="holder-item-row">
										<div className="item-sign">
											<p>
												-اینجانب ...... {print?.seller?.profile?.stR_FName + " " + print?.seller?.profile?.stR_LName}.... مشترک تلفن همراه ...
												{print?.seller?.msisdn}
												...ضمن انتقال کلیه حقوق قانونی و متصوره شماره همراه مذکور به خریدار ، اعلام می دارم در صورت وجود هر گونه ممنوعیت قانونی اعم از
												دستور قضائی مبنی بر ممنوعیت نقل و انتقال سیم کارت همچنان ذیل نام اینجانب باقی مانده و کلیه مسئولیت های قانونی مترتب بر عهده
												انتقال دهنده خواهد بود .همچنین تایید مینمایم که یک نسخه از فرم تغییر مالکیت را از فروشنده دریافت نموده ام .
												<br />
												-انتقال دهنده موظف به تسویه حساب سیمکارت دائمی تا تاریخ .................... میباشد.
												<br />
												-انتقال دهنده با امضای این فرم اقرار و اذعان می نماید کلیه مبلغ ما به ازای انتقال سیم کارت را دریافت نموده و حق هر گونه ادعایی
												را نسبت به شماره همراه مذکور و اپراتور از خود سلب و ساقط می نماید.
											</p>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div className="hold-personal">
							<div className="holder-list">
								<div className="holder-item-row">
									<ul>
										<li>
											<div className="label">امضا و اثر انگشت انتقال دهنده :</div>
											<div className="value"></div>
										</li>
										<li>
											<div className="label"> امضا و اثر انگشت انتقال گیرنده :</div>
											<div className="value"></div>
										</li>
										<li>
											<div className="label"> مهرفروشگاه/ فروشنده :</div>
											<div className="value"></div>
										</li>
									</ul>
								</div>
							</div>
						</div>
						{/* <div className="holder-notes" >
              <p>
                که سیم کارت های اعتباری اپراتور پس از فعالسازی به مدت سه ماه روز متوالی هیچ تراکنشی ( به غیر از تراکنش های رایگان ) نداشته باشد

                اپراتور میتواند طبق شرایط ذکر شده در قرارداد مشترکین اعتباری ، بر اساس وجود یا عدم وجود اعتبار در حساب مشترک ، نسبت به قطع دو طرفه یا
                سلب امتیاز شماره سیم کارت اقدام نماید و همچنین سیم کارت های دائمی نیز در صورت عدم پرداخت بدهی به مدت یکسال از زمان مسدودیت خط مطابق با
                شرایط ذکر شده در قرارداد مشترکین دائمی و مصوبه شماره 3 جلسه 207 کمیسیون تنظیم مقررات و ارتباطات تخلیه شده و امتیاز آن ها سلب می گردد.
              </p>
            </div> */}
					</div>
				) : (
					<div className="print-document-cw" dir="ltr">
						<div className="header-doc border-row">
							<div className="row-doc">
								<div className="item-logo">
									<img src={process.env.PUBLIC_URL + "/assets/images/logo-small.png"} alt="" />
								</div>
								<div className="item-title">
									<div className="hold-title">
										<h2>SIM Card Change of Ownership Form</h2>
									</div>
								</div>
								<div className="item-date">
									Date: <span dir="ltr">{formatDate(new Date().toISOString())}</span>
								</div>
							</div>
						</div>
						<div className="holder-with-label border-row">
							<div className="item-block" data-content="information of the transferee (buyer)">
								<div className="item-block-prefix">
									<span>information of the transferee (buyer)</span>
								</div>
								<div className="holder-list">
									<div className="holder-item-row">
										<ul>
											<li>
												<div className="label">SIM Card NO:</div>
												<div className="value">
													<span dir="ltr">{print?.buyer?.profile?.smsmobileno}</span>
												</div>
											</li>
											<li>
												<div className="label"> KIT NO :</div>
												<div className="value">{print?.prefactor?.iccid?.slice(9, 19)}</div>
											</li>
										</ul>
									</div>
									<div className="holder-item-row">
										<ul>
											<li>
												<div className="label">Name : </div>
												<div className="value">{print?.buyer?.profile?.fname}</div>
											</li>
											<li>
												<div className="label"> Last Name :</div>
												<div className="value">{print?.buyer?.profile?.lname}</div>
											</li>
											<li>
												<div className="label"> National ID/Passport:</div>
												<div className="value">{print?.buyer?.profile?.certno}</div>
											</li>
											<li>
												<div className="label"> Father's Name:</div>
												<div className="value">{print?.buyer?.profile?.fathername}</div>
											</li>
										</ul>
									</div>
									<div className="holder-item-row">
										<ul>
											<li>
												<div className="label"> Date Of Birth :</div>
												<div className="value">{formatDate(print?.buyer?.profile?.birthdate)}</div>
											</li>
											<li>
												<div className="label">Postal code : </div>
												<div className="value">{print?.buyer?.profile?.postalcode}</div>
											</li>
											<li>
												<div className="label"> State :</div>
												<div className="value">{print?.buyer?.profile?.txtProvince}</div>
											</li>
											<li>
												<div className="label"> City/village :</div>
												<div className="value">{print?.buyer?.profile?.txtCity}</div>
											</li>
										</ul>
									</div>
									<div className="holder-item-row">
										<ul>
											<li>
												<div className="label">Exact address (place of residence / SIM card delivery):</div>
												<div className="value">
													{print?.buyer?.profile?.mainstreet}, {print?.buyer?.profile?.auxiliaryroad}, {print?.buyer?.profile?.alley},{" "}
													{print?.buyer?.profile?.buildingno}, {print?.buyer?.profile?.floor}, {print?.buyer?.profile?.unit}
												</div>
											</li>
										</ul>
									</div>
								</div>
							</div>
							<div className="item-block" data-content="Transferor's (Seller's) Information ">
								<div className="item-block-prefix">
									<span>Transferor's (Seller's) Information</span>
								</div>
								<div className="holder-list">
									<div className="holder-item-row">
										<ul>
											<li>
												<div className="label">SIM Card NO :</div>
												<div className="value">{print?.seller?.smsmobile}</div>
											</li>
											<li>
												<div className="label"> KIT NO:</div>
												<div className="value"></div>
											</li>
											<li>
												<div className="label"> National ID/Passport:</div>
												<div className="value">{print?.seller?.certno}</div>
											</li>
										</ul>
									</div>
									<div className="holder-item-row">
										<ul>
											<li>
												<div className="label">Name : </div>
												<div className="value">{print?.seller?.profile?.stR_FName}</div>
											</li>
											<li>
												<div className="label">Last Name :</div>
												<div className="value">{print?.seller?.profile?.stR_LName}</div>
											</li>
											<li>
												<div className="label">National ID/Passport:</div>
												<div className="value">{print?.seller?.profile?.stR_CertNo}</div>
											</li>
											<li>
												<div className="label"> Father's Name:</div>
												<div className="value">{print?.seller?.profile?.stR_FatherName}</div>
											</li>
										</ul>
									</div>
									<div className="holder-item-row">
										<ul>
											<li>
												<div className="label"> Date Of Birth :</div>
												<div className="value">{formatDate(print?.seller?.profile?.dtE_BirthDate)}</div>
											</li>
											<li>
												<div className="label">Postal code : </div>
												<div className="value">{print?.seller?.profile?.address?.stR_PostalCode}</div>
											</li>
											<li>
												<div className="label"> State :</div>
												<div className="value">{print?.seller?.profile?.province?.stR_ProvinceName}</div>
											</li>
											<li>
												<div className="label"> City/village :</div>
												<div className="value">{print?.seller?.profile?.city?.stR_CityName}</div>
											</li>
										</ul>
									</div>
									<div className="holder-item-row">
										<ul>
											<li>
												<div className="label">Exact address (place of residence / SIM card delivery):</div>
												<div className="value">
													{print?.seller?.profile?.address?.stR_MainStreet}, {print?.seller?.profile?.address?.stR_AuxiliaryRoad},{" "}
													{print?.seller?.profile?.address?.stR_Alley}, {print?.seller?.profile?.address?.stR_BuildingNo},{" "}
													{print?.seller?.profile?.address?.stR_Floor}, {print?.seller?.profile?.address?.stR_Unit}
												</div>
											</li>
										</ul>
									</div>
								</div>
							</div>

							<div className="item-block" data-content="Transferor's  Obligations">
								<div className="item-block-prefix">
									<span>Transferor's Obligations</span>
								</div>
								<div className="holder-list">
									<div className="holder-item-row">
										<div className="item-sign">
											<p>
												- I ....{print?.seller?.profile?.stR_FName + " " + print?.seller?.profile?.stR_LName}.... mobile phone subscriber
												{print?.seller?.msisdn}.... while transferring all legal rights The accompanying number to the buyer, I declare that in case
												of any legal prohibition, it will remain under my name and all legal responsibilities will be the responsibility of the
												transferor. I also confirm that I have received a copy of the change of ownership form from the seller.
												<br />- The transferor is obliged to settle the account of the permanent SIM Card until the date of .................... By
												signing this form, the transferor acknowledges that he has received all the amount for the transfer of the SIM Card and waives
												the right of any claim against the mentioned mobile number and the Operator.
											</p>
										</div>
									</div>
								</div>
							</div>
							<div className="item-block" data-content="transferee's Obligations">
								<div className="item-block-prefix">
									<span>transferee's Obligations</span>
								</div>
								<div className="holder-list">
									<div className="holder-item-row">
										<div className="item-sign">
											<p>
												- I ....{print?.buyer?.profile?.fname + " " + print?.buyer?.profile?.lname}....... undertake not to have any claims against
												the operator if this deal breaks down for any reason, and by signing this document, I will replace the transfer and all
												financial and non-financial responsibilities resulting from the subscription of this mobile number to the operator and other
												competent authorities will be my responsibility. I also confirm that I have received a copy of the ownership change form from
												the seller.
												<br />- The transferee undertakes to complete the transfer form for the next transfer while referring to the sales agent of
												this company, otherwise the transfer will not be used against the Operator.
											</p>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div className="hold-personal">
							<div className="holder-list">
								<div className="holder-item-row">
									<ul>
										<li>
											<div className="label">Signature/fingerprint of the applicant:</div>
											<div className="value"></div>
										</li>
										<li>
											<div className="label"> Date :</div>
											<div className="value"></div>
										</li>
										<li>
											<div className="label"> stamp store/seller :</div>
											<div className="value"></div>
										</li>
									</ul>
								</div>
							</div>
						</div>
						{/* <div className="holder-notes">
							<p>
								If Irancell Telecommunications Services Company's Prepaid SIM Cards, are not used for 90 consecutive days after activation for payable
								transactions, Irancell, in compliance with the conditions under the Prepaid Subscribers ' Agreement, will have the right to hard
								suspend or deactivate the SIM Card, with the subscriber losing SIM Card, taking in to account the subscriber's airtime amount.
								Likewise, if a post-paid subscriber fails to pay its bill within 1 year after soft suspension, the post-paid SIM Card will be
								deactivated, with the subscriber losing the SIM Card, in compliance with the conditions under the Post-paid Subscribers' Agreement and
								the provisions under Resolution 207-3 of Communications Regulatory Commission
							</p>
						</div> */}
					</div>
				)}
			</div>
		</>
	);
};

export default CWPrint;
